import { ArrowRight, Phone } from "lucide-react";

const heroAreas = [
  "Sports Law, Agency and Business Development",
  "Taxation Advisory & Litigation",
  "Criminal & Civil Litigation",
];

const HeroCTAs = ({ onBookClick }) => (
  <div className="flex flex-col sm:flex-row gap-4 pt-4">
    <button
      onClick={onBookClick}
      data-testid="hero-cta-primary"
      className="bg-gold text-navy-dark px-8 py-4 text-sm font-semibold tracking-wide hover:bg-gold-hover transition-all duration-300 flex items-center justify-center gap-2 group"
    >
      Book a Consultation
      <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
    </button>
    <a
      href="tel:+919914601473"
      data-testid="hero-cta-secondary"
      className="border border-gold/30 text-gold px-8 py-4 text-sm font-medium tracking-wide hover:bg-gold hover:text-navy-dark transition-all duration-300 flex items-center justify-center gap-2"
    >
      <Phone className="w-4 h-4" />
      Call Us Now
    </a>
  </div>
);

const HeroPanel = () => (
  <div className="hidden lg:flex flex-col justify-center items-end" data-testid="hero-right">
    <div className="border border-gold/20 p-12 space-y-8">
      <div className="space-y-3">
        <p className="text-xs tracking-[0.4em] uppercase text-gold/60 font-body">Established in Delhi</p>
        <div className="h-px w-full bg-gold/20" />
      </div>
      <div className="space-y-6">
        {heroAreas.map((area, i) => (
          <div key={area} className="flex items-center gap-4">
            <span className="text-gold font-heading text-2xl">0{i + 1}</span>
            <span className="text-sm text-gray-300 font-body tracking-wide">{area}</span>
          </div>
        ))}
      </div>
      <div className="h-px w-full bg-gold/20" />
      <p className="text-xs text-gold/40 font-body italic">Advisory and litigation. Under one roof.</p>
    </div>
  </div>
);

export default function HeroSection() {
  const scrollToContact = () => {
    const el = document.querySelector("#contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hero" data-testid="hero-section" className="relative flex items-center pt-20 md:pt-24">
      <div className="absolute inset-0 bg-navy-dark">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(197,165,114,0.06)_0%,_transparent_60%)]" />
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/20 to-transparent" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 w-full py-10 md:py-14">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-20 items-center">
          <div className="space-y-8">
            <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl tracking-tight leading-[0.95] text-white">
              Where Advisory Meets the{" "}
              <em className="text-gold not-italic">Courtroom.</em>
            </h1>

            <p className="font-body text-base md:text-lg text-gray-400 max-w-lg leading-relaxed">
              Partner-led counsel. National reach. Three disciplines. One firm.
            </p>

            <HeroCTAs onBookClick={scrollToContact} />
          </div>

          <HeroPanel />
        </div>
      </div>
    </section>
  );
}
